<section class="common-container"></section>

<style lang="scss">
  :global {
    @import '../../modules/common/styles/global-styles.scss';
  }
</style>
